import { useContext, useMemo } from 'react';
import DashboardsContext from '../../contexts/DashboardsContext';
import cardTypeCheckers from '../../types/cardTypeCheckers';
import { getCompositeScorecardIds } from 'components/Studio/kpiList';

const useScorecardUsageReport = (scorecard?: Scorecards.Scorecard) => {
  const { allDashboards } = useContext(DashboardsContext);

  const usage = useMemo<Scorecards.UsageReport>(() => {
    const result = { dashboards: [] } as Scorecards.UsageReport;
    if (!scorecard) {
      return result;
    }
    allDashboards.forEach((dashboard) => {
      // As a card, or in a Studio Composite's KPI list Table
      const isOnThisDashboard = dashboard.canvas.cards.some((c) =>
        cardTypeCheckers.isScorecard(c)
          ? c.content.scorecardId === scorecard.id
          : cardTypeCheckers.isStudioComposite(c) &&
            getCompositeScorecardIds(c.content.composite.rows).includes(
              scorecard.id,
            ),
      );

      if (isOnThisDashboard) {
        result.dashboards.push({ id: dashboard.id, name: dashboard.name });
      }
    });
    return result;
  }, [allDashboards, scorecard]);

  const isUsed = usage.dashboards.length > 0;
  const isUsedInMultiplePlaces = usage.dashboards.length > 1;

  const usageWarningMessage = useMemo(() => {
    if (!isUsedInMultiplePlaces) {
      return '';
    }
    let message = 'This KPI List appears in multiple dashboards:';
    usage.dashboards.forEach((d) => {
      message += `\n- ${d.name}`;
    });
    return message;
  }, [isUsedInMultiplePlaces, usage.dashboards]);

  return {
    usage,
    isUsedInMultiplePlaces,
    usageWarningMessage,
    isUsed,
  };
};

export default useScorecardUsageReport;
